import React from "react";
import { Info } from "@phosphor-icons/react";
import { DISCLOSURE } from "../../lib/clarity";

export default function Disclosure({ testid = "clarity-disclosure", text = DISCLOSURE, className = "" }) {
  return (
    <div data-testid={testid} className={`border border-exodus-border bg-exodus-surface/60 p-5 flex gap-3 ${className}`}>
      <Info size={18} className="text-exodus-gold shrink-0 mt-0.5" />
      <p className="text-xs text-exodus-muted leading-relaxed">{text}</p>
    </div>
  );
}
